export default "__VITE_ASSET__78a2a28d__"